module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANBAMAAABvB5JxAAAAAXNSR0IB2cksfwAAABVQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgEApAAAAAd0Uk5TADCQn6Dc24DP5zgAAABBSURBVHicYxBgAAJGBmUQ5cTAYsDAwOLAwODMwOACFGAxAHGAXBCHgYE1AUy5OINIFgeQYpAyZ4geIFcFYgrETADwSgVPqJ5drwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-view--exit.png
// module id = 795
// module chunks = 0